import { render } from "./languageFunctionMap.vue?vue&type=template&id=8b0e827c&scoped=true"
import script from "./languageFunctionMap.vue?vue&type=script&lang=js"
export * from "./languageFunctionMap.vue?vue&type=script&lang=js"

import "./languageFunctionMap.vue?vue&type=style&index=0&id=8b0e827c&scoped=true&lang=css"

import exportComponent from "D:\\code\\humanbrainview\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8b0e827c"]])

export default __exports__